/* Copyright (C) NewFoundry 2021 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var brightsmith_analytics_1 = require("brightsmith-analytics");

var react_jss_1 = __importDefault(require("react-jss"));

var react_redux_1 = require("react-redux");

var webCore = __importStar(require("./index"));

var util_1 = require("./util");

var Web = /*#__PURE__*/function () {
  function Web() {
    _classCallCheck(this, Web);

    this.core = webCore;
    this.wrappedComponents = {};
  }

  _createClass(Web, [{
    key: "debug",
    value: function debug(components) {
      var ignore = ['theme'];
      var wrappedKeys = Object.keys(this.wrappedComponents);
      Object.keys(components).forEach(function (c) {
        if (wrappedKeys.indexOf(c) === -1) {
          if (ignore.indexOf(c) !== -1) {
            return;
          }

          console.warn("Brightsmith Web has not init ".concat(c, " for web (this may cause errors)"));
        }
      });
    }
  }, {
    key: "init",
    value: function init(component, theme) {
      var library = Object.assign(Object.assign(Object.assign({}, this.core), this.wrappedComponents), {
        styles: {},
        theme: theme,
        AnalyticsApi: brightsmith_analytics_1.AnalyticsApi
      });
      var wrappedComponent;
      var mapStateToProps = component.mapStateToProps,
          mapDispatchToProps = component.mapDispatchToProps,
          name = component.name,
          style = component.style,
          withRouter = component.withRouter;
      var Component = component[name];
      wrappedComponent = Component(library);

      if (style) {
        var themedStyle = style(theme);
        var mergedStyles = util_1.mergeWebStyles(themedStyle);
        wrappedComponent = react_jss_1.default(mergedStyles)(wrappedComponent);
      }

      if (mapDispatchToProps || mapStateToProps) {
        wrappedComponent = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(wrappedComponent);
      }

      if (withRouter) {
        wrappedComponent = withRouter(wrappedComponent);
      }

      this.wrappedComponents[name] = wrappedComponent;
      return wrappedComponent;
    }
  }, {
    key: "getCore",
    value: function getCore() {
      return this.core;
    }
  }]);

  return Web;
}();

exports.default = Web;